import EmblaSlider from "@/app/components/lib/Embla-slider";
import { TSlideWidith } from "@/app/components/lib/Embla-slider/EmblaSliderContainer";
import { JSX } from "react";

type TProps = {
  children: React.ReactElement[];
};

const GallerySlider: React.FC<TProps> = ({ children }) => {
  const width = 92;

  return (
    <EmblaSlider>
      <EmblaSlider.EmblaSliderViewport>
        <EmblaSlider.EmblaSliderContainer
          gap={32}
          slides={[
            ...(children as Array<JSX.Element>)?.map((child) => ({
              component: <div style={{ width: width }}>{child}</div>,
              width: "auto" as TSlideWidith,
            })),
          ]}
        />
        <EmblaSlider.EmblaFilters />
      </EmblaSlider.EmblaSliderViewport>
    </EmblaSlider>
  );
};

export default GallerySlider;
